// src/components/Dashboard/SupportHelpline.jsx

import { useLanguage } from "../../context/LanguageContext";

export default function SupportHelpline() {
  const { t } = useLanguage();
  return (
    <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow h-full text-gray-900 dark:text-gray-100">
      <h2 className="text-lg font-semibold mb-2">{t('support_reach_out_title')}</h2>
      <p className="text-sm text-gray-700 dark:text-gray-300 mb-2">
        {t('support_reach_out_body')}
      </p>
    </div>
  );
}